// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { ArrowRight } from "../components/Icons";
import { Collapse } from "@material-ui/core";
import List from "@material-ui/core/List";
import ButtonBase from "@material-ui/core/ButtonBase";
import classnames from "classnames";

const styles = (theme) => ({
    topicItem: {
        backgroundColor: "#fff",
        border: "1px solid #d6d8db",
        borderRadius: 3,
        marginBottom: 4,
    },
    topicItemTitle: {
        fontFamily: "MANEurope, Arial, sans-serif",
        fontWeight: "bold",
        textTransform: "uppercase",
        fontSize: 14,
        padding: 16,
        display: "flex",
        alignItems: "center",
    },
    topicItemNumber: {
        color: "#e40045",
        minWidth: 30,
    },
    icon: {
        marginLeft: "auto",
        color: "#303c49",
    },
    iconOpen: {
        transform: "rotate(90deg)",
    },
});

const EMobilityTocTopic = ({ classes, title, number, children, open, to }) => {
    return (
        <div className={classes.topicItem}>
            <ButtonBase component={Link} className={classes.topicItemTitle} to={to}>
                {number && <span className={classes.topicItemNumber}>{number}</span>}
                <span>{title}</span>
                <ArrowRight className={classnames(classes.icon, { [classes.iconOpen]: open })} size={12} />
            </ButtonBase>
            <Collapse in={open}>
                <List disablePadding dense>
                    {children}
                </List>
            </Collapse>
        </div>
    );
};

export default compose(withStyles(styles))(EMobilityTocTopic);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityTocTopic.js